module.exports = {"TXTCLI_Game_Information":{"id":"TXTCLI_Game_Information","defaultMessage":"Informações sobre os Jogos"}}